import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiProbationPolicy, ApiProbationPolicyPayload } from "@/types/probation-policy.types.ts";

export const apiProbationPolicies = {
  getAll: () => {
    return api.get<ApiProbationPolicy[]>("/api/v1/probation-policies");
  },
  create: (payload: ApiProbationPolicyPayload) => {
    return api.post<ApiProbationPolicy>("/api/v1/probation-policies", payload);
  },
  update: (id: number, payload: ApiProbationPolicyPayload) => {
    return api.put<ApiProbationPolicy>(`/api/v1/probation-policies/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/probation-policies/${id}`);
  },
};
